class UnAuthError extends Error {
  code: number | string;
  path?: string;

  constructor(message: string, code = 401) {
    super(message);
    this.name = 'UnAuthError';
    this.code = code;
  }
}

export { UnAuthError };
